import { type RouterOutputs } from './trpc';

type BackendPostUpload = NonNullable<
  RouterOutputs['posts']['singlePost']['posts'][0]['uploads']
>[0];

type PostUpload = BackendPostUpload & {
  url?: string; // used by private posts on frontend
};

export type Post = Omit<
  RouterOutputs['posts']['singlePost']['posts'][0],
  'uploads'
> & {
  isPrivate?: boolean; // Flag for private posts
  uploads: PostUpload[] | null;
};

export type PostResponse = RouterOutputs['posts']['feed'] & {
  //added by frontend
  nextTimestamp?: number;
};
export type PostReferencesResponse = RouterOutputs['posts']['references'];
export type WithdrawnPostResponse = RouterOutputs['posts']['withdrawn'];
export type PostEditHistoryItem =
  RouterOutputs['posts']['editHistory']['edits'][0];
export type BotSettings = {
  modelId: number;
  temperature: number;
  maxOutputTokens: number;
};

export type EngagementTimer = {
  startTime: number;
  duration: number;
};

// Mirrors `enum UserTag` in schema.prisma, which shared/all cannot import. Add a
// value here when it is added there.
export enum UserTag {
  HUMAN = 'HUMAN',
  BOT = 'BOT',
  GOVERNMENT = 'GOVERNMENT',
  ACADEMIA = 'ACADEMIA',
  BUSINESS = 'BUSINESS',
  NEW = 'NEW',
  WAITLIST = 'WAITLIST',
  VERIFIED = 'VERIFIED'
}

export enum VoteType {
  UPVOTE = 'UPVOTE',
  DOWNVOTE = 'DOWNVOTE'
}

export enum postDataSort {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY'
}

// Content flags read from a post's factiiis. Pure, so a component that only
// needs to know whether to blur a post does not call usePosts for it.
type NamedFactiii = { name: string };

const hasFactiii = (factiiis: readonly NamedFactiii[], name: string) =>
  factiiis.some((factiii) => factiii.name.toLowerCase() === name);

export const isNsfw = (factiiis: readonly NamedFactiii[]) =>
  hasFactiii(factiiis, 'nsfw');

// A post in the politics space counts even without the factiii, but a post
// with no factiiis at all is never flagged (as before this moved here).
export const isPolitics = (
  factiiis: readonly NamedFactiii[],
  space: string | undefined | null
) =>
  factiiis.length > 0 &&
  (hasFactiii(factiiis, 'politics') || space === 'politics');

export const isTroll = (factiiis: readonly NamedFactiii[]) =>
  hasFactiii(factiiis, 'troll');
